import classNames from "classnames";
import {
  type ButtonHTMLAttributes,
  forwardRef,
  type ReactNode,
  type Ref,
} from "react";
import { Icon } from "../Icon/Icon.tsx";
import { BaseButton } from "./BaseButton.tsx";
import styles from "./button.module.css";
import type { ButtonSize } from "./Button.tsx";

export const SelectButton = forwardRef(
  (
    {
      children,
      disabled,
      size = "md",
      className,
      style,
      isOpen = false,
      ...rest
    }: {
      children?: ReactNode;
      size?: ButtonSize;
      isOpen?: boolean;
      style?: React.CSSProperties;
    } & ButtonHTMLAttributes<HTMLButtonElement>,
    ref: Ref<HTMLButtonElement>,
  ) => (
    <BaseButton
      ref={ref}
      className={classNames(
        "px-100 rounded-150",
        disabled
          ? "bg-input-surface-disabled"
          : "bg-input-surface-rest hover:bg-input-surface-hover",
        styles[size],
        className,
      )}
      style={style}
      type="button"
      disabled={!!disabled}
      children={
        <div className="flex-row-center">
          <div className="flex-fill">{children}</div>
          <Icon name={isOpen ? "ChevronUp" : "ChevronDown"} size="sm" />
        </div>
      }
      {...rest}
    />
  ),
);
